import { GzSingleSelectComplexBaseDataProvider } from '../GzSingleSelectComplexBaseDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { DEFAULT_DATA_LIMIT, GetItemsRequest, GetItemsResponse } from '../../types';
import { PhasrRecommendationsMethod } from '../../../../phasrRecommendations/phasrRecommendationsGrid/types';

export class PhasrBehavioralIdentitiesDataProvider extends GzSingleSelectComplexBaseDataProvider {
  private endpoint = 'BehavioralProfiles';

  public async getItems({ searchValue, page, limit, context }: any): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: this.endpoint,
        method: PhasrRecommendationsMethod.GET_PHASR_BEHAVIORAL_IDENTITIES_AGGREGATE,
        payload: {
          page,
          limit,
          companyId: context?.companyId,
          filter: [
            {
              property: 'behavioralProfileIdentityName',
              value: searchValue,
            },
            {
              property: 'objectId',
              value: context?.objectId,
            },
            {
              property: 'collection',
              value: context?.collection,
            },
            {
              property: 'mode',
              value: Number(context?.mode),
            },
          ],
        },
      });

      return {
        items: response.records.map(user => ({
          value: user.behavioralProfileIdentity,
          label: user.behavioralProfileIdentityName + ' (' + user.departmentName + ')',
          extraDetails: {
            department: {
              id: user.departmentId,
              status: user.departmentStatus,
              totalItems: user.departmentTotalProfiles,
              name: user.departmentName,
              totalRestrictedItems: user.departmentRestrictedProfiles,
            },
            user: {
              id: user.behavioralProfileIdentity,
              status: user.userStatus,
              name: user.behavioralProfileIdentityName,
              totalItems: user.userTotalProfiles,
              totalRestrictedItems: user.userRestrictedProfiles,
            }
          },
        })),
        totalItemsCount: response.totalRecords,
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  public async getInitialItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const context = await request.context;
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: this.endpoint,
        method: PhasrRecommendationsMethod.GET_PHASR_BEHAVIORAL_IDENTITIES_AGGREGATE,
        payload: {
          page: 1,
          limit: DEFAULT_DATA_LIMIT,
          companyId: context?.companyId,
          filter: [
            {
              property: 'objectId',
              value: context?.objectId,
            },
            {
              property: 'collection',
              value: context?.collection,
            },
            {
              property: 'mode',
              value: Number(context?.mode),
            },
          ],
        },
      });
      const items = response.records.map(user => ({
        value: user.behavioralProfileIdentity,
        label: user.behavioralProfileIdentityName + ' (' + user.departmentName + ')',
        extraDetails: {
          department: {
            id: user.departmentId,
            status: user.departmentStatus,
            totalItems: user.departmentTotalProfiles,
            name: user.departmentName,
            totalRestrictedItems: user.departmentRestrictedProfiles,
          },
          user: {
            id: user.behavioralProfileIdentity,
            status: user.userStatus,
            name: user.behavioralProfileIdentityName,
            totalItems: user.userTotalProfiles,
            totalRestrictedItems: user.userRestrictedProfiles,
          }
        },
      }));

      return {
        items: items,
        totalItemsCount: response.totalRecords,
      };
    } catch (e) {
      throw new Error(e);
    }
  }
}
